export const PATH = {
  LOGIN: "/",
  HOME: "/home",
  FORBIDDEN: "/403",
  ORDER: "/orders",
};
